import type { StrapiLink } from "@/shared/api/strapi";
import { Link } from "@/shared/ui/link/Link";

import styles from "./Header.module.css";

type HeaderNavProps = {
  items: StrapiLink[];
  className?: string;
};

export const HeaderNav = ({ items, className }: HeaderNavProps) => {
  if (items.length === 0) return null;

  const navClassName = className ? `${styles.nav} ${className}` : styles.nav;

  return (
    <nav className={navClassName}>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <Link href={item.href} type={item.type} className={styles.link}>
              {item.text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
